export const customFormatDate = (dateStr, locale) => {
  if (!dateStr) return ""

  const [day, month, year] = dateStr.split(".")
  const date = new Date(year, month - 1, day)

  let result = new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short",
  }).format(date)

  result = result.replace(
    /(\d{2})\s(.+)/,
    (_, d, m) => `${d} ${m.charAt(0).toUpperCase()}${m.slice(1)}`
  )

  return result
}

export const formatFullDate = (dateStr, locale) => {
  if (!dateStr) return ""
  const [day, month, year] = dateStr.split(".")
  const date = new Date(year, month - 1, day)

  return new Intl.DateTimeFormat(locale, {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date)
}

export const customFormatDateV2 = (input, locale = "ru-RU") => {
  if (!input) return ""
  // output 10 окт. 2025
  const [day, month, year] = input.split(".").map(Number)

  const date = new Date(year, month - 1, day)

  return date.toLocaleDateString(locale, {
    day: "numeric",
    month: "short",
    year: "numeric",
  })
}

export const strToDate = (str) => {
  if (!str) return new Date()
  const [day, month, year] = str.split(".").map(Number)
  return new Date(year, month - 1, day)
}

const parseDateString = (dateStr) => {
  const [day, month, year] = dateStr.split(".").map(Number)
  return new Date(year, month - 1, day)
}

export const formatDate = (day, date) => {
  return `${String(day).padStart(2, "0")}.${String(date.getMonth() + 1).padStart(2, "0")}.${date.getFullYear()}`
}

export const getDatesBetween = (startDate, endDate) => {
  const dates = []
  const start = parseDateString(startDate)
  const end = parseDateString(endDate)

  const [earlierDate, laterDate] = start <= end ? [start, end] : [end, start]

  const current = new Date(earlierDate)
  while (current <= laterDate) {
    dates.push(formatDate(current.getDate(), current))
    current.setDate(current.getDate() + 1)
  }

  return dates
}

export const normalizeDates = (dates) => {
  if (!Array.isArray(dates) || dates.length === 0) return null
  return dates.length === 1 ? dates[0] : dates
}

export const calculateNights = (fromDate, toDate) => {
  // Парсинг дат в формате DD.MM.YYYY или YYYY-MM-DD
  const parseDate = (dateStr) => {
    if (dateStr.includes(".")) {
      // Формат DD.MM.YYYY
      const [day, month, year] = dateStr.split(".")
      return new Date(year, month - 1, day)
    } else {
      // Формат YYYY-MM-DD
      return new Date(dateStr)
    }
  }

  const from = parseDate(fromDate)
  const to = parseDate(toDate)
  const diffTime = to - from
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  return diffDays
}

export const formatDateV2 = (date) => {
  if (!date) return null
  const d = Array.isArray(date) ? date[0] : date
  // если уже строка вида "2025-09-09" → конвертируем в "09.09.2025"
  return d?.split("-").reverse().join(".") ?? null
}
